import cx from 'classnames'

import classes from './styles.module.scss'

type Props = {
  title: string
  value?: string
  onClick?: () => void
  children?: any
  className?: string
  dataTest?: string
}

function UserInfoRow(props: Props) {
  return (
    <div className={cx(classes.userInfoRow, classes[props.className])}>
      <span className={classes.userInfoRowTitle}>{props.title}</span>
      <div data-test={props.dataTest} className={classes.userInfoRowValue} onClick={props.onClick}>
        {props.children ? props.children : props.value}
      </div>
    </div>
  )
}

export default UserInfoRow
